var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93555 2H10.4355V3H9.43555V9.5C9.43555 9.63261 9.38287 9.75979 9.2891 9.85355C9.19533 9.94732 9.06816 10 8.93555 10H1.93555C1.80294 10 1.67576 9.94732 1.58199 9.85355C1.48823 9.75979 1.43555 9.63261 1.43555 9.5V3H0.435547V2H2.93555V0.5C2.93555 0.367392 2.98823 0.240215 3.08199 0.146447C3.17576 0.0526784 3.30294 0 3.43555 0H7.43555C7.56816 0 7.69533 0.0526784 7.7891 0.146447C7.88287 0.240215 7.93555 0.367392 7.93555 0.5V2ZM8.43555 3H2.43555V9H8.43555V3ZM3.93555 4.5H4.93555V7.5H3.93555V4.5ZM5.93555 4.5H6.93555V7.5H5.93555V4.5ZM3.93555 1V2H6.93555V1H3.93555Z",
    fill: "#080C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f8f23385c649453b2666a8893ed308e1.svg";
export { ForwardRef as ReactComponent };